import React from "react";
import DevelopersContent from "../components/developers/developers-content";

const Developers = () => {
  return <DevelopersContent></DevelopersContent>;
};

export default Developers;
